export const zIndex = {
  under: -1,
  base: 0,
  over: 5, // when an absolute positioned element needs to go over
  header: 10,
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  error: 1400,
  snackbar: 1500,
  tooltip: 1600,
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/theme/z-index.ts